// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"28154d90","977":"240addac"}[chunkId] + ".chunk.js";
};